<script setup>
import {
  BadgeCheck,
  Bell,
  ChevronsUpDown,
  CreditCard,
  LogOut,
  Sparkles,
} from "lucide-vue-next";

import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from '@/components/ui/avatar';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from '@/components/ui/sidebar';

import { useViewStore } from '@/stores/viewStore'

const viewStore = useViewStore();

import { useUserStore } from '@/stores/userStore';

const userStore = useUserStore();

const props = defineProps({
  user: { type: Object, required: true },
});

const { isMobile } = useSidebar();

import { useI18n } from 'vue-i18n';

const { t } = useI18n();

</script>

<template>
  <SidebarMenu>
	<SidebarMenuItem>
		<SidebarMenuButton>	
			<LogOut />
			<a href="/logout"> {{ t('view.logout') }}</a>
			
		</SidebarMenuButton>
	</SidebarMenuItem>
  </SidebarMenu>
</template>
